module.exports = __webpack_public_path__ + "static/media/AnimacaoQrPedir.7d590a9b.gif";